var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "pt-1": "", "fill-height": "", row: "", wrap: "" } },
    [
      _c(
        "v-flex",
        {
          staticClass: "user--info__avatar",
          attrs: { "mt-2": "", "xs-2": "" }
        },
        [
          _c("v-avatar", { attrs: { size: "40", color: "primary" } }, [
            _vm.user.entity.avatar
              ? _c("img", { attrs: { src: _vm.user.entity.avatar.link } })
              : _c("span", { staticClass: "headline white--text" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("acronym")(_vm.fullname)) +
                      "\n      "
                  )
                ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "user--info__main",
          attrs: { "mt-2": "", "ml-1": "", xs10: "", "text-xs-left": "" }
        },
        [
          _c("div", [_c("b", [_vm._v(" " + _vm._s(_vm.fullname) + " ")])]),
          _vm._v(" "),
          _c(
            "ul",
            {
              staticClass: "pl-0 user--info__coordinates mt-2",
              staticStyle: { "list-style": "none" }
            },
            [
              _c("li", { staticClass: "mb-1" }, [_vm._v(_vm._s(_vm.presence))]),
              _vm._v(" "),
              _c("li", { staticClass: "mb-1" }, [
                _vm._v(_vm._s(_vm.summonNextMeeting))
              ]),
              _vm._v(" "),
              _vm.user.type === "creator"
                ? _c("li", { staticClass: "mb-1" }, [
                    _vm._v(_vm._s(_vm.$t(_vm.lblSetting.lblCreator)))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.user.ib.length
                ? _c(
                    "v-layout",
                    { attrs: { row: "" } },
                    _vm._l(_vm.user.ib, function(item) {
                      return _c(
                        "div",
                        {
                          class:
                            (item.color ? "" : "primary ") +
                            "text-xs-center mr-2 mt-2",
                          style: {
                            height: "32px",
                            width: "32px",
                            "border-radius": "50%",
                            padding: "5px",
                            "padding-top": "5px",
                            "background-color": "#" + item.color
                          }
                        },
                        [
                          item.character_problem.picto
                            ? _c("v-img", {
                                style: { height: 22 + "px", width: 22 + "px" },
                                attrs: { src: item.character_problem.picto }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    })
                  )
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b80eec2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b80eec2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/building-monitor/components/bm-user-profile-widget/template.html
// module id = null
// module chunks = 